import { memo, useContext, useState, useMemo } from "react";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "./itemTypes";
import {
    Box,
    useColorModeValue,
    Text,
    Flex,
    IconButton,
    Icon,
    theme,
    Tooltip,
    useMediaQuery,Grid,
    Tag,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { AiFillTwitterCircle } from "react-icons/ai";
import { AiFillEye, AiFillEdit } from "react-icons/ai";
import { useSession } from "next-auth/client";
import { TweetContext } from "../../context/tweetContext";
import { unschedule } from "../../controllers/schedule";
import { hasAdvancedOptions } from "utils/tweetUtils";
import { getAccount } from "utils/sessionHelper";
import { useMiscellaneousContext } from "context/miscellaneousContext";
import { text as textTheme } from "theme/foundations/text";
import { border } from "theme/foundations/border";
import { color, layerStyle, radius, textStyle } from "theme/names";
import { FiTwitter } from "react-icons/fi";
import { colors } from "theme/colors/colors";

//@ts-ignore
export const Card = memo(function Card({ id, card, text, moveCard, findCard, hoverCard, isHovered, time, openTweet }) {
// export const Card = ({ id, text, moveCard, findCard }) => {

    const [session, loading] = useSession();
    const tweetContext: any = useContext(TweetContext);
    const [isTooSmall] = useMediaQuery("(max-width: 800px)");
    const [isLoadingEdit, setIsLoadingEdit] = useState(false);
    const miscellaneousContext: any = useMiscellaneousContext();

    // console.log("id: " + id);
    const originalIndex = findCard(id);
    // const originalIndex = 1;
    // const originalCard = {...card};
    // const originalCard = card.id;

    const [{ isDragging }, drag] = useDrag(
        () => ({
            type: card.isEvergreen ? "evergreen" : ItemTypes.CARD,
            item: { id, originalIndex },
            canDrag: props => card.tweet ? true : false,
            collect: (monitor) => ({
                isDragging: monitor.isDragging()
            }),
            end: (item, monitor) => {
                const { id: droppedId, originalIndex } = item;
                const didDrop = monitor.didDrop();
                if (!didDrop) {
                    // moveCard(item.id, originalIndex);
                }
                else {
                    moveCard(item.id);
                }
            }
        }),
        [id, originalIndex, moveCard]
    );

    //@ts-ignore
    const [, drop] = useDrop(() => ({
            accept: ItemTypes.CARD,
            canDrop: () => false,
            hover({ id: draggedId }) {
                if (draggedId !== id) {
                    // const { index: overIndex } = findCard(id);
                    const slotOver = findCard(id);
                    // moveCard(draggedId, slotOver);
                    hoverCard(slotOver);
                }
            }
        }),
        [findCard, moveCard]
    );

    const getIcon = () => {
        let icon;
        if (card.isEvergreen)
            icon = (
              <Grid
                {...{
                    layerStyle: "evergreen",
                    // py: 1,
                        // ml: 1,
                        w: 6,
                    placeContent: "center",
                }}
              >
                <svg
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0625 11.1875C14.5 11.7188 14.625 12.4062 14.3125 13.0312C14.0625 13.625 13.4688 14 12.8125 14H8.25V15.25C8.25 15.6875 7.90625 16 7.5 16C7.0625 16 6.75 15.6875 6.75 15.2812V14H2.15625C1.5 14 0.90625 13.625 0.65625 13.0312C0.34375 12.4062 0.46875 11.7188 0.90625 11.1875L2.03125 9.90625C1.8125 9.75 1.625 9.5625 1.53125 9.3125C1.25 8.75 1.34375 8.09375 1.75 7.625L2.71875 6.5C2.59375 6.375 2.46875 6.1875 2.375 6.03125C2.15625 5.53125 2.25 4.96875 2.625 4.5625L6.40625 0.5C6.65625 0.1875 7.0625 0 7.5 0C7.90625 0 8.3125 0.1875 8.5625 0.5L12.3438 4.5625C12.7188 4.96875 12.8125 5.53125 12.5938 6.03125C12.5 6.1875 12.4062 6.375 12.25 6.5L13.2188 7.625C13.625 8.09375 13.7188 8.75 13.4375 9.3125C13.3438 9.5625 13.1562 9.75 12.9375 9.90625L14.0625 11.1875ZM12.9688 12.4062C13 12.375 13 12.2812 12.9375 12.1875L9.9375 8.71875H12L9.3125 5.375H11.0312L7.46875 1.5L3.9375 5.375H5.65625L2.96875 8.71875H5.03125L2.03125 12.1875C1.96875 12.2812 1.96875 12.375 2 12.4062C2.03125 12.4688 2.09375 12.5 2.15625 12.5H6.75V9.3125L5.4375 8.03125C5.125 7.75 5.125 7.28125 5.4375 6.96875C5.71875 6.6875 6.1875 6.6875 6.5 6.96875L6.75 7.1875V5.75C6.71875 5.3125 7.0625 5 7.5 5C7.90625 5 8.21875 5.3125 8.25 5.75V9.6875L8.46875 9.5C8.75 9.1875 9.21875 9.1875 9.5 9.5C9.8125 9.78125 9.8125 10.25 9.5 10.5312L8.25 11.8125V12.5H12.8125C12.875 12.5 12.9375 12.4688 12.9688 12.4062Z"
                    fill="currentColor"
                  />
                </svg>
              </Grid>
            );
        else if (card?.tweet?.text?.includes("\n\n\n"))
            icon = (
                <Grid {...{
                    color: "taplio.500",
                    w:6 ,
                    // color: color["primary.lightMode.300"], _dark: { color: color["primary.darkMode.300"] },
                    // ml: 1,
                placeItems: "center",
                } }>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 5.5V4.5H12.5V5.5H2.5ZM1.25 1.5C0.8125 1.5 0.5 1.1875 0.5 0.75C0.5 0.34375 0.8125 0 1.25 0H13.75C14.1562 0 14.5 0.34375 14.5 0.75C14.5 1.1875 14.1562 1.5 13.75 1.5H12.5V3.5H2.5V1.5H1.25ZM4 1.5V2.5H11V1.5H4ZM12.5 8.5V9.5H2.5V8.5H12.5ZM14 6.5C14.25 6.5 14.5 6.75 14.5 7C14.5 7.28125 14.25 7.5 14 7.5H2.5V6.5H14ZM13.75 14.5C14.1562 14.5 14.5 14.8438 14.5 15.25C14.5 15.6875 14.1562 16 13.75 16H1.25C0.8125 16 0.5 15.6875 0.5 15.25C0.5 14.8438 0.8125 14.5 1.25 14.5H2.5V12.5H12.5V14.5H13.75ZM11 14.5V13.5H4V14.5H11ZM2.5 11.5V10.5H12.5V11.5H2.5Z"
                    fill="currentColor"
                  />
                </svg>
              </Grid>
            );
        else if (card?.tweet)
            icon = (
                <Grid {...{w: 6 , placeContent: "center"}}>
                <FiTwitter {...{ fontSize: "18px", color: "#5A97DB" }} />
                </Grid>
                );
        return (
            <Box>
                {icon}
            </Box>
        )
    }
    const tweetLabels = useMemo(() => getAccount(session)?.tweetLabels, [session, miscellaneousContext.refreshLabels]);
    const label = tweetLabels?.find(l => l.id === card?.labels?.[0])
  const labelsLinkedToTweet = tweetLabels?.filter(l => card?.tweet?.labels?.includes(l.id));

    const opacity = isDragging ? 0 : 1;
    const isNextSlot = time?.getTime() == tweetContext?.nextSlot?.getTime();

    let bgColorDefault = useColorModeValue("white", "#1E1E1E");
    // let bgColorEvergreen = useColorModeValue("green.50", "green.900");
    let bgColorHovered = useColorModeValue(
        "border.lightMode.hover",
        "border.darkMode.hover"
    );
    let bgColorSlot = useColorModeValue(
        "background.lightMode.disabled",
        "background.darkMode.disabled"
    );
    // let bgColorDefault = useColorModeValue("blue.50", "blue.800");
    let bgColorEvergreen = useColorModeValue(colors.crm.lightMode[20], colors.crm.darkMode[40]); 
    let bgColorThread = useColorModeValue("taplio.100", "taplio.900");
    // let bgColorHovered = useColorModeValue("gray.300", "gray.600");
    // let bgColorNextSlot = useColorModeValue("gray.50", "gray.700");
    // let bgColorTweet = useColorModeValue(theme.colors.gray[300], theme.colors.gray[600]);
    // let colorEye = useColorModeValue("gray.600", "gray.100");

    let style: any = {
        bg: bgColorDefault,
      };
    
      if (card.isEvergreen) {
        // style.bg = bgColorEvergreen;
      } else if (isHovered) {
        style.bg = bgColorHovered;
      } else if (!card.tweet) {
        style.bg = bgColorSlot;
        // style.border = "1px " + bgColorTweet;
      }

    if (card.isEvergreen) {
        style.bg = bgColorEvergreen;
        // style.color = "black";
    }
    else if (card?.tweet?.text?.includes("\n\n\n")) {
        style.bg = bgColorThread;
    }
    else if (isHovered) {
        style.bg = bgColorHovered;
    }
    // else if (isNextSlot) {
    //     style.bg = bgColorNextSlot;
    // }
    // else if (!card.tweet) {
    //     style.bg = "transparent";
    //     style.border = "1px dashed " + bgColorTweet;
    // }

    let isAutoRT = false, isAutoPlug = false, isAutoDM = false, dmString = "";
    if (card.tweet) {
      const [, options] = hasAdvancedOptions(card.tweet);
      isAutoRT = options?.isAutoRetweet;
      isAutoPlug = options?.isAutoPlug;
      isAutoDM = options?.isAutoDm;
      dmString = options?.dmString;
    }


    return (
      <Flex
        // justifyContent="space-between"
        ref={(node) => drag(drop(node))}
        opacity={opacity}
        rounded="xl"
        mb={2}
        p={2}
        // pl={5}
        // justifyContent="space-between"
        alignItems="center"
        {...border.default.light}
        {...style} // bg
        {...textTheme.body.medium.light.light}
        _dark={{
          ...border.default.dark,
          ...textTheme.body.medium.light.dark,
        }}
        _hover={{
          borderColor: !card.tweet ? undefined: "transparent",
          boxShadow: card.tweet
            ? "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)"
            : "none",
        }}
        h="50px"
        cursor={!card.isEvergreen && card.tweet ? "move" : "pointer"}
        onClick={() => {
          if (card.tweet) {
            openTweet(card.tweet);
          } else {
            let newTime = new Date(card.time);
            // let newTimeTimezoned = convertToAccountTimezone(newTime, getAccount(session)?.timezone).date;
            // console.log("newTimeTimezoned: " + newTimeTimezoned);
            tweetContext.open();
            tweetContext.setNextSlot(newTime);
            // console.log(tweetContext.textState);

            // let textState = tweetContext?.textState ?? tweetContext?.refComposer?.current?.textState();
            let textState =
              tweetContext?.refComposer?.current?.textState() ??
              tweetContext?.textState;
            tweetContext.setTextState({
              ...textState,
              scheduledTime: newTime,
            });
            // tweetContext.refComposer.current.textState()
            // console.log("set scheduledTime to " + card.time);
          }
        }}
      >
        {card.tweet && (
          <Grid
            {...{
              display: ["none", "grid"], // hide on very small screens
              h: "32px",
              w: "32px",
              minW: "32px",
              bg: "primary.lightMode.100",
              _dark: {
                bg: "primary.darkMode.100",
              },
              borderRadius: radius.sm,
              fontSize: "14px",
              placeContent: "center",
            }}
          >
            <Icon {...{ viewBox: "0 0 14 15" }}>
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 7.75C14 11.6328 10.8555 14.75 7 14.75C3.11719 14.75 0 11.6328 0 7.75C0 6.30078 0.4375 4.96094 1.20312 3.83984C1.39453 3.53906 1.80469 3.45703 2.10547 3.64844C2.40625 3.86719 2.48828 4.27734 2.26953 4.57812C1.66797 5.48047 1.28516 6.57422 1.28516 7.75C1.28516 10.8945 3.85547 13.4375 6.97266 13.4375C10.1172 13.4375 12.6875 10.8945 12.6875 7.75C12.6875 4.85156 10.4727 2.44531 7.65625 2.11719V3.59375C7.65625 3.97656 7.35547 4.25 6.97266 4.25C6.61719 4.25 6.31641 3.97656 6.31641 3.59375V1.40625C6.31641 1.05078 6.61719 0.75 6.97266 0.75C10.8555 0.75 14 3.89453 14 7.75ZM7.4375 7.28516C7.71094 7.55859 7.71094 7.96875 7.4375 8.21484C7.19141 8.48828 6.78125 8.48828 6.53516 8.21484L4.34766 6.02734C4.07422 5.78125 4.07422 5.37109 4.34766 5.09766C4.59375 4.85156 5.00391 4.85156 5.25 5.09766L7.4375 7.28516Z"
                  fill="hsl(203, 100%, 36%)"
                />
              </svg>
            </Icon>
          </Grid>
        )}
        {/* <Flex alignItems="center" maxW={{ base: "80%", md: "70%", lg: "75%" }}> */}
        <Text
          textStyle={textStyle["body.medium.light"]}
          layerStyle={card.isEvergreen ? "evergreen" : undefined}
          fontSize="sm"
          w="80px"
          minW="80px"
          ml={
            card.tweet
              ? [2, 4]
              : card.isEvergreen
              ? ["2px", "42px"]
              : ["8px", "48px"]
          }
                mr={card.isEvergreen? 1.5: 0}
        >
          {format(time, "hh:mm aaa")}
        </Text>
        {getIcon()}

        {card.tweet && (
          // <Text fontWeight="600" ml={6} maxW={{ base: "80%", md: "70%", lg: "75%" }} overflow="hidden" noOfLines={1} wordBreak="break-all" >{card.tweet.text}</Text>

          <Text
            textStyle={textStyle["body.medium.light"]}
            ml={card?.tweet?.idCompany ? 2 : 4}
            mr={12}
            flex={1}
            noOfLines={1}
            wordBreak={"break-all"}
            {...textTheme.body.medium.standard.light}
            _dark={{
              ...textTheme.body.medium.standard.dark,
            }}
          >
            {card.tweet.text}
          </Text>
        )}
        {card.isEvergreen && (
          <Box
            {...{
              layerStyle: layerStyle.evergreen,
            }}
            // fontWeight="600" ml={2} maxW={"80%"} overflow="hidden" noOfLines={1} wordBreak="break-all"
            fontSize="xs"
            ml={2}
          >
            Evergreen slot
          </Box>
        )}
        {isNextSlot && (
          // <Text as="i" fontWeight="400" fontSize="sm" ml={6} maxW={"80%"} overflow="hidden" noOfLines={1} wordBreak="break-all" >Press "Add to queue" to place your tweet here</Text>
          <Text
            textStyle={textStyle["small.medium.light"]}
            as="i"
            ml={[0, card.isEvergreen ? "8px" : "36px"]}
            overflow="hidden"
            noOfLines={1}
            wordBreak={"break-all"}
            {...textTheme.body.medium.light.light}
            _dark={{
              ...textTheme.body.medium.light.dark,
            }}
          >
            Press "Add to queue" to place your post here
          </Text>
        )}
        {label && !card.tweet && (
          <Flex {...{flex: 1, justifyContent: "flex-end"}}>
            <Tag
              placeSelf="flex-end"
              mr={1}
              // variant={"secondary"}
              colorScheme={label.color}>
              {label.title}
            </Tag>
          </Flex>
        )}
        {card.tweet && (
          <Flex alignItems="center">
            {!isTooSmall && labelsLinkedToTweet?.length > 0 && (
              <Flex mr="2">
                {labelsLinkedToTweet.map((l) => (
                  <Tag
                    key={l.id}
                    mr={2}
                    colorScheme={l.color}
                    fontSize={"xs"}
                  >
                    {l.title}
                  </Tag>
                ))}
              </Flex>
            )}
            {!isTooSmall && isAutoPlug && (
              //   <Tooltip isLazy label={`Will plug a tweet at ${card.tweet.autoPlugTrigger} likes`}>
              <Text
                cursor="default"
                mr="5"
                onClick={(e) => e.stopPropagation()}
              >
                <svg width="14" height="14" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0938 1.625C12.375 3.71875 14 7.15625 14 8.8125C14 12.7812 10.8438 16 7 16C3.125 16 0 12.7812 0 8.8125C0 6.5625 2.15625 2.875 5.25 0C6.4375 1.125 7.5 2.3125 8.34375 3.5C8.875 2.84375 9.4375 2.21875 10.0938 1.625ZM7 14.5C10.0312 14.5 12.5 11.9688 12.5 8.8125C12.5 7.84375 11.5 5.5625 10.0625 3.78125C9.875 4 9.6875 4.21875 9.5 4.4375L8.28125 5.9375L7.125 4.375C6.59375 3.625 5.9375 2.84375 5.25 2.125C2.875 4.65625 1.5 7.40625 1.5 8.8125C1.5 11.9688 3.96875 14.5 7 14.5ZM9.78125 7.625C9.90625 7.8125 10 7.96875 10.0938 8.15625C10.8438 9.59375 10.5312 11.4062 9.1875 12.3438C8.59375 12.7812 7.84375 13 7.0625 13C5.09375 13 3.5 11.7188 3.5 9.59375C3.5 8.53125 4.15625 7.59375 5.46875 6C5.65625 6.21875 8.1875 9.4375 8.1875 9.4375L9.78125 7.625Z" fill="currentColor"/>
                </svg>
              </Text>
              //   </Tooltip>
            )}
            {!isTooSmall && isAutoDM && (
              //   <Tooltip isLazy label={`Will sent a DM on ${dmString}`}>
              <Text
                cursor="default"
                mr="4"
                onClick={(e) => e.stopPropagation()}
              >
                {/* 🗨️ */}
                <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.9688 0C16.0938 0 16.9688 0.90625 16.9688 2V10.9688C16.9688 12.0312 16.0625 12.9375 14.9688 12.9375H10.4688L6.5625 15.8438C6.3125 16.0312 5.96875 15.875 5.96875 15.5625V12.9375H2.96875C1.84375 12.9375 0.96875 12.0625 0.96875 10.9688V2C0.96875 0.90625 1.84375 0 2.96875 0H14.9688ZM15.5 11V2C15.5 1.75 15.25 1.5 15 1.5H3C2.71875 1.5 2.5 1.75 2.5 2V11C2.5 11.2812 2.71875 11.5 3 11.5H7.5V13.375L10 11.5H15C15.25 11.5 15.5 11.2812 15.5 11Z" fill="currentColor"/>
                </svg>
              </Text>
              //   </Tooltip>
            )}
            {!isTooSmall && isAutoRT && (
              //   <Tooltip isLazy label={`Will be auto-retweeted ${card.tweet.autoRetweetTimes > 1 ? card.tweet.autoRetweetTimes + " times every" : " in"} ${card.tweet.autoRetweetHours} hour${card.tweet.autoRetweetHours > 1 ? "s" : ""}`}>
              <Text
                cursor="default"
                mr="4"
                onClick={(e) => e.stopPropagation()}
              >
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 4.84375L5.96875 7.75C6.0625 8.15625 5.8125 8.5625 5.40625 8.65625C5.34375 8.6875 5.28125 8.6875 5.21875 8.6875C4.90625 8.6875 4.59375 8.46875 4.5 8.125L4.25 7.03125L2.125 10.5625C1.9375 10.875 1.9375 11.25 2.09375 11.5312L2.15625 11.7188C2.34375 12.0625 2.6875 12.25 3.0625 12.25H4.25C4.65625 12.25 5 12.5938 5 13.0312C5 13.4375 4.65625 13.75 4.25 13.75H3.0625C2.125 13.75 1.25 13.2188 0.8125 12.375L0.75 12.2188C0.375 11.4375 0.40625 10.5312 0.84375 9.8125L2.84375 6.4375L1.96875 6.78125C1.5625 6.90625 1.15625 6.71875 1 6.34375C0.84375 5.9375 1.0625 5.5 1.4375 5.375L4.25 4.3125C4.46875 4.25 4.6875 4.25 4.875 4.34375C5.0625 4.4375 5.1875 4.625 5.25 4.84375ZM5.5625 3.40625C5.1875 3.1875 5.09375 2.75 5.28125 2.375L5.8125 1.5C6.28125 0.71875 7.09375 0.25 8 0.25C8.875 0.25 9.6875 0.71875 10.1562 1.5L11.8438 4.3125L12 3.40625C12.0625 3 12.4375 2.71875 12.875 2.8125C13.2812 2.875 13.5312 3.25 13.4688 3.65625L12.9688 6.625C12.9375 6.84375 12.8125 7.03125 12.625 7.15625C12.5 7.21875 12.375 7.25 12.25 7.25C12.1562 7.25 12.0938 7.25 12.0312 7.25L9.125 6.375C8.75 6.28125 8.5 5.84375 8.625 5.46875C8.75 5.0625 9.15625 4.84375 9.5625 4.9375L10.6562 5.28125L8.84375 2.25C8.5 1.65625 7.46875 1.65625 7.125 2.25L6.59375 3.15625C6.375 3.5 5.90625 3.625 5.5625 3.40625ZM15.125 9.8125C15.5625 10.5312 15.5938 11.4375 15.2188 12.2188L15.1562 12.375C14.7188 13.2188 13.8438 13.75 12.9062 13.75H8.96875L9.71875 14.4688C10.0312 14.7188 10.0625 15.2188 9.78125 15.5C9.65625 15.6875 9.4375 15.75 9.25 15.75C9.0625 15.75 8.875 15.6875 8.75 15.5625L6.5 13.5625C6.3125 13.4375 6.25 13.2188 6.25 13C6.25 12.8125 6.3125 12.5938 6.5 12.4688L8.75 10.4688C9.03125 10.1875 9.53125 10.2188 9.8125 10.5312C10.0625 10.8125 10.0312 11.3125 9.75 11.5625L8.96875 12.25H12.9062C13.2812 12.25 13.625 12.0625 13.8125 11.7188L13.875 11.5625C14.0312 11.25 14.0312 10.875 13.8438 10.5625L13.125 9.40625C12.9375 9.03125 13.0312 8.59375 13.4062 8.375C13.75 8.15625 14.2188 8.28125 14.4375 8.625L15.125 9.8125Z" fill="currentColor"/>
                </svg>

              </Text>
              //   </Tooltip>
            )}
            {!isTooSmall && (
              // <IconButton
              //     aria-label="view"
              //     color="twitter.600"
              //     variant="tertiary"
              //     size="sm"
              //     mr={2}
              //     onClick={async (e) => {
              //     }}
              //     icon={
              //         <Icon color={colorEye} fontSize="lg" as={AiFillEye} />
              //     }
              // />
              <Tooltip hasArrow label="Preview">
                <IconButton
                  aria-label="Preview"
                  // color="twitter.600"
                  variant="action"
                  size="table"
                  mr={2}
                  onClick={async (e) => {}}
                  icon={
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 12C8 9.8125 9.78125 8 12 8C14.1875 8 16 9.8125 16 12C16 14.2188 14.1875 16 12 16C9.78125 16 8 14.2188 8 12ZM12 14.5C13.375 14.5 14.5 13.4062 14.5 12C14.5 10.625 13.375 9.5 12 9.5C11.9688 9.5 11.9375 9.5 11.9062 9.5C11.9688 9.6875 12 9.84375 12 10C12 11.125 11.0938 12 10 12C9.8125 12 9.65625 12 9.5 11.9375C9.5 11.9688 9.5 12 9.5 12C9.5 13.4062 10.5938 14.5 12 14.5ZM5.96875 7.53125C7.4375 6.15625 9.46875 5 12 5C14.5 5 16.5312 6.15625 18 7.53125C19.4688 8.875 20.4375 10.5 20.9062 11.625C21 11.875 21 12.1562 20.9062 12.4062C20.4375 13.5 19.4688 15.125 18 16.5C16.5312 17.875 14.5 19 12 19C9.46875 19 7.4375 17.875 5.96875 16.5C4.5 15.125 3.53125 13.5 3.0625 12.4062C2.96875 12.1562 2.96875 11.875 3.0625 11.625C3.53125 10.5 4.5 8.875 5.96875 7.53125ZM12 6.5C9.9375 6.5 8.28125 7.4375 7 8.625C5.78125 9.75 4.96875 11.0625 4.53125 12C4.96875 12.9375 5.78125 14.2812 7 15.4062C8.28125 16.5938 9.9375 17.5 12 17.5C14.0312 17.5 15.6875 16.5938 16.9688 15.4062C18.1875 14.2812 19 12.9375 19.4375 12C19 11.0625 18.1875 9.75 16.9688 8.625C15.6875 7.4375 14.0312 6.5 12 6.5Z"
                          fill="currentColor"
                        />
                      </svg>
                  }
                />
              </Tooltip>
            )}
            {/* <Tooltip isLazy hasArrow label="edit and re-schedule"> */}
            {/* <IconButton
                                    aria-label="Edit"
                                    color="twitter.600"
                                    variant="tertiary"
                                    size="sm"
                                    isLoading={isLoadingEdit}
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        setIsLoadingEdit(true);
                                        await unschedule(session, card.tweet, tweetContext);
                                        setIsLoadingEdit(false);
                                        tweetContext.open();
                                    }}
                                    icon={
                                        <Icon color={colorEye} fontSize="lg" as={AiFillEdit} />
                                    }
                                /> */}
            {/* </Tooltip> */}
            <Tooltip hasArrow label="Edit">
              <IconButton
                aria-label="Edit"
                variant="action"
                size="table"
                // size="sm"
                isLoading={isLoadingEdit}
                onClick={async (e) => {
                  e.stopPropagation();
                  setIsLoadingEdit(true);
                  await unschedule(session, card.tweet, tweetContext);
                  setIsLoadingEdit(false);
                  tweetContext.open();
                }}
                icon={
                  <Icon fontSize="22px">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.6562 4.78125C16.5312 3.90625 17.9375 3.90625 18.8125 4.78125L19.2188 5.1875C20.0938 6.0625 20.0938 7.46875 19.2188 8.34375L13.0312 14.5312C12.7812 14.7812 12.4375 15 12.0625 15.0938L8.9375 16C8.6875 16.0625 8.40625 16 8.21875 15.7812C8 15.5938 7.9375 15.3125 8 15.0625L8.90625 11.9375C9 11.5625 9.21875 11.2188 9.46875 10.9688L15.6562 4.78125ZM17.75 5.84375C17.4688 5.5625 17 5.5625 16.7188 5.84375L15.7812 6.75L17.25 8.21875L18.1562 7.28125C18.4375 7 18.4375 6.53125 18.1562 6.25L17.75 5.84375ZM10.3438 12.3438L9.8125 14.1875L11.6562 13.6562C11.7812 13.625 11.875 13.5625 11.9688 13.4688L16.1875 9.25L14.75 7.8125L10.5312 12.0312C10.4375 12.125 10.375 12.2188 10.3438 12.3438ZM10.25 6C10.6562 6 11 6.34375 11 6.75C11 7.1875 10.6562 7.5 10.25 7.5H6.75C6.03125 7.5 5.5 8.0625 5.5 8.75V17.25C5.5 17.9688 6.03125 18.5 6.75 18.5H15.25C15.9375 18.5 16.5 17.9688 16.5 17.25V13.75C16.5 13.3438 16.8125 13 17.25 13C17.6562 13 18 13.3438 18 13.75V17.25C18 18.7812 16.75 20 15.25 20H6.75C5.21875 20 4 18.7812 4 17.25V8.75C4 7.25 5.21875 6 6.75 6H10.25Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Icon>
                }
              />
            </Tooltip>
          </Flex>
        )}
      </Flex>
    );
});
